export default "__VITE_ASSET__5adc6530__"